import { Component, Input, OnInit } from '@angular/core'
import { FormControl } from '@angular/forms'
import { LabelToId } from 'src/app/common/input-utils'

@Component({
  selector: 'app-textarea',
  templateUrl: './textarea.component.html',
  styleUrls: ['./textarea.component.scss'],
  standalone: false,
})
export class TextareaComponent implements OnInit {
  @Input() control: FormControl<string | null>
  @Input() label: string
  @Input() required: boolean = false
  @Input() placeholder: string
  @Input() errorText: string
  @Input() describedBy?: string
  id: string
  errorId: string

  ngOnInit() {
    this.id = LabelToId(this.label)
    this.errorId = `${this.id}-error`
  }

  get isInvalid(): boolean {
    return this.control?.invalid === true && this.control?.touched === true
  }
}
